import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-google-plus",
  "use": "icon-google-plus-usage",
  "viewBox": "0 0 46.4 29.7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 46.4 29.7\" id=\"icon-google-plus\">\n<path d=\"M46.4,16.5L46.4,16.5h-5.1v5.1h-3.4v-5.1h-5.1v-3.4h5.1V8h3.4v5.1h5.1V16.5L46.4,16.5z M14.9,12.7v5.1h8.4\n\tc-0.3,2.2-2.5,6.4-8.4,6.4c-5.1,0-9.2-4.2-9.2-9.4c0-5.2,4.1-9.4,9.2-9.4c2.9,0,4.8,1.2,5.9,2.3l4-3.9C22.2,1.5,18.9,0,14.9,0\n\tC6.6,0,0,6.6,0,14.9s6.6,14.9,14.9,14.9c8.6,0,14.3-6,14.3-14.5c0-1-0.1-1.7-0.2-2.5C28.9,12.7,14.9,12.7,14.9,12.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/google-plus.svg
// module id = 136
// module chunks = 0 1 2